import { TActions } from '../../types';
import { CHECK_SERVICE_FAIL, CHECK_SERVICE_START, CHECK_SERVICE_SUCCESS, CHANGE_AUTO_PROLONG } from './actions';
import { defaultState, defaultAutoProlongInfo } from './defaultState';
import { ECheckServiceStatus, ICheckoutInfoState } from './types';

export function checkoutInfo(state: ICheckoutInfoState = defaultState, action: TActions): ICheckoutInfoState {
  switch (action.type) {
    case CHECK_SERVICE_START: {
      return {
        ...state,
        status: ECheckServiceStatus.pending,
        errorCode: null,
      };
    }

    case CHECK_SERVICE_SUCCESS: {
      const { autoProlongInfo, ...checkoutInfo } = action.payload;

      return {
        ...state,
        ...checkoutInfo,
        status: ECheckServiceStatus.success,
        autoProlongInfo: {
          ...autoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHECK_SERVICE_FAIL: {
      return {
        ...defaultState,
        status: ECheckServiceStatus.fail,
        errorCode: action.payload,
        autoProlongInfo: {
          ...defaultAutoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHANGE_AUTO_PROLONG: {
      return {
        ...state,
        autoProlongInfo: {
          ...state.autoProlongInfo,
          isChecked: action.payload,
        },
      };
    }

    default:
      return state;
  }
}
